<script setup>
import {ref} from 'vue'
import createBicycleInventory from './components/createBicycleInventory/index.vue'
import {addBicycles} from "@/api/bicycles/bicycles.js"
import router from "@/router/index.js"

// 加载状态
const loading = ref(false)

/*表单信息相关*/
// 表单
const ruleForm = ref({
  assetOwner: "BIKING UP",
  brandName: null,
  model: null,
  color: null,
  ageRange: null,
  providerSponsor: null,
  conditionLevel: null,
  bicycleQuantity: 0,
  currentVenue: null,
  placementDate: null
})
// 新增车辆锚点
const createBicycleInventoryRef = ref()
// 处理提交新增车辆
const handleAddBicycles = async () => {
  try {
    loading.value = true
    await addBicycles(null, ruleForm.value)
    ElMessage.success("新增成功")
    router.push("/listBicycleInventory")
  } catch (e) {
    console.log(e)
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div v-loading="loading" style="height: 100%">
    <createBicycleInventory
        ref="createBicycleInventoryRef"
        v-model="ruleForm"
        :loading="loading"
        @success="handleAddBicycles"
    ></createBicycleInventory>
  </div>
</template>

<style lang="scss" scoped>

</style>
